import React from 'react'
import PropTypes from 'prop-types'
import { KeyboardAvoidingView, Platform, View } from 'react-native'
import { isMobileDevice } from '../../tools/platform'

const KeyboardView = ({ children }) => {
  return isMobileDevice() ? (
    <KeyboardAvoidingView
      style={{ flex: 1 }}
      {...(Platform.OS === 'ios' && { behavior: 'padding' })}
    >
      <View style={{ flex: 1, justifyContent: 'flex-end' }}>
        {children}
      </View>
    </KeyboardAvoidingView>
  ) : (
    <>
      {children}
    </>
  )
}
KeyboardView.propTypes = {
  children: PropTypes.node.isRequired
}
export default KeyboardView
